/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw101'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw101'">Sw101</vs-button>
          <vs-button :color="sel==='sw102'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw102'">Sw102</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 (Sw101) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Local Account &amp; Telnet VTY — Sw101</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Items.filter(i=>sw101Completion[i.key]).length }}/{{ task1Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:sw101Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(sw101Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="sw101Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 2 (Sw101) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Named ACL ENT_ACL — Sw101</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Items.filter(i=>sw101Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:sw101Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(sw101Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="sw101Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 (Sw102) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Port Security — Sw102</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Items.filter(i=>sw102Completion[i.key]).length }}/{{ task3Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:sw102Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(sw102Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="sw102Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw101Completion.saved,sw102Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="devKey in ['sw101','sw102']" :key="'s-'+devKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ devKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getState(devKey).endDone?'#28C76F':'transparent',border:'2px solid '+(getState(devKey).endDone?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getState(devKey).endDone?'text-success':''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(devKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(devKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(devKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw101'" key="sw101" id="sw101_terminal" :commands="sw101Commands" :prompt="sw101Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw101" />
          <vue-command v-show="sel==='sw102'" key="sw102" id="sw102_terminal" :commands="sw102Commands" :prompt="sw102Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="Sw102" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const SHOW_IFACE_BRIEF =
  'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>' +
  'Vlan100&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.100.1&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
  'Vlan200&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;192.168.200.1&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Named_Access_list_Port_Security_Sim.png',
      sel: 'sw101',
      totalScore: 0,

      task1Items: [
        { key: 'username',       cmd: 'username support privilege 15 password max2learn' },
        { key: 'lineVty',        cmd: 'line vty 0 4' },
        { key: 'transportTelnet',cmd: 'transport input telnet' },
        { key: 'loginLocal',     cmd: 'login local' },
        { key: 'vtyExited',      cmd: 'exit' },
        { key: 'endForVerify',   cmd: 'end' },
        { key: 'verifyShowIp',   cmd: 'show ip interface brief' },
      ],
      task2Items: [
        { key: 'aclCreated',   cmd: 'ip access-list extended ENT_ACL' },
        { key: 'denyIcmp',     cmd: 'deny icmp host 192.168.200.10 host 192.168.100.10' },
        { key: 'permitTelnet', cmd: 'permit tcp host 192.168.200.10 host 192.168.100.1 eq telnet' },
        { key: 'denyTelnet',   cmd: 'deny tcp 192.168.200.0 0.0.0.255 any eq telnet' },
        { key: 'permitIp',     cmd: 'permit ip 192.168.200.0 0.0.0.255 any' },
        { key: 'aclExited',    cmd: 'exit' },
        { key: 'intE02',       cmd: 'interface e0/2' },
        { key: 'accessGroup',  cmd: 'ip access-group ENT_ACL in' },
      ],
      task3Items: [
        { key: 'intE00',           cmd: 'interface e0/0' },
        { key: 'portSecurity',     cmd: 'switchport port-security' },
        { key: 'portSecMax',       cmd: 'switchport port-security maximum 4' },
        { key: 'portSecViolation', cmd: 'switchport port-security violation protect' },
      ],

      sw101: { mode: 'exec', currentInterface: null, currentAcl: null, endDone: false },
      sw102: { mode: 'exec', currentInterface: null, endDone: false },

      sw101Completion: {
        username: false, lineVty: false, transportTelnet: false, loginLocal: false,
        vtyExited: false, endForVerify: false, verifyShowIp: false,
        aclCreated: false, denyIcmp: false, permitTelnet: false,
        denyTelnet: false, permitIp: false, aclExited: false,
        intE02: false, accessGroup: false, saved: false,
      },
      sw102Completion: {
        intE00: false, portSecurity: false, portSecMax: false,
        portSecViolation: false, saved: false,
      },

      sw101Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.sw101Configure(x),
        conf:      (x) => this.sw101Configure(x),
        exit:      () => this.sw101Exit(),
        end:       () => this.sw101End(),
        username:  (x) => this.sw101Username(x),
        line:      (x) => this.sw101Line(x),
        transport: (x) => this.sw101Transport(x),
        login:     (x) => this.sw101Login(x),
        ip:        (x) => this.sw101Ip(x),
        permit:    (x) => this.sw101Permit(x),
        deny:      (x) => this.sw101Deny(x),
        interface: (x) => this.sw101Interface(x),
        int:       (x) => this.sw101Interface(x),
        show:      (x) => this.sw101Show(x),
        copy:      (x) => this.sw101Copy(x),
      },
      sw102Commands: {
        help:       () => createStdout(HELP),
        enable:     () => createStdout(''),
        configure:  (x) => this.sw102Configure(x),
        conf:       (x) => this.sw102Configure(x),
        exit:       () => this.sw102Exit(),
        end:        () => this.sw102End(),
        interface:  (x) => this.sw102Interface(x),
        int:        (x) => this.sw102Interface(x),
        switchport: (x) => this.sw102Switchport(x),
        copy:       (x) => this.sw102Copy(x),
      },
    };
  },

  computed: {
    sw101Prompt() {
      const m = this.sw101.mode;
      if (m === 'config') return 'Sw101(config)#';
      if (m === 'config-line') return 'Sw101(config-line)#';
      if (m === 'config-ext-nacl') return 'Sw101(config-ext-nacl)#';
      if (m === 'config-if') return 'Sw101(config-if)#';
      return 'Sw101#';
    },
    sw102Prompt() {
      const m = this.sw102.mode;
      if (m === 'config') return 'Sw102(config)#';
      if (m === 'config-if') return 'Sw102(config-if)#';
      return 'Sw102#';
    },
    task1Done() {
      return ['username','lineVty','transportTelnet','loginLocal','vtyExited','endForVerify','verifyShowIp'].every(k => this.sw101Completion[k]);
    },
    task2Done() {
      return ['aclCreated','denyIcmp','permitTelnet','denyTelnet','permitIp','aclExited','intE02','accessGroup'].every(k => this.sw101Completion[k]);
    },
    task3Done() {
      return ['intE00','portSecurity','portSecMax','portSecViolation'].every(k => this.sw102Completion[k]);
    },
    saveDone() { return this.sw101Completion.saved && this.sw102Completion.saved; },
  },

  watch: {
    'sw101Completion.accessGroup'(val) { if (val) this.switchTo('sw102'); },
    'sw102Completion.saved'(val) { if (val && !this.sw101Completion.saved) this.switchTo('sw101'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    getState(k) { return this[k]; },
    getCompletion(k) { return this[k + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(dev) {
      this.sel = dev;
      this.$nextTick(() => {
        const el = document.querySelector(`#${dev}_terminal input, #${dev}_terminal textarea`);
        if (el) el.focus();
      });
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        return createStderr('% Must be in configuration mode — type "exit" to leave current submode first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-line') return createStderr('% Must be in line config mode — type "line vty 0 4" first');
      if (needed === 'config-ext-nacl') return createStderr('% Must be in ACL config mode — type "ip access-list extended ENT_ACL" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — enter an interface first');
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.sw101Completion, this.sw102Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 21) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    // ── Sw101 ────────────────────────────────────────────────────
    sw101Configure(x) {
      const me = this.modeErr(this.sw101, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this.sw101.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    sw101Exit() {
      const s = this.sw101; const c = this.sw101Completion;
      if (s.mode === 'config-line') {
        if (c.loginLocal && !c.vtyExited) { c.vtyExited = true; this.updateScore(); }
        s.mode = 'config';
        return createStdout(this.guide('Exited VTY config. → Next: type "end" to reach exec mode, then run "show ip interface brief" to confirm Sw101\'s management IP.'));
      }
      if (s.mode === 'config-ext-nacl') {
        if (c.permitIp && !c.aclExited) { c.aclExited = true; this.updateScore(); }
        s.mode = 'config'; s.currentAcl = null;
        return createStdout(this.guide('All four ACL entries saved. → Next: "interface e0/2" to apply ENT_ACL inbound.'));
      }
      if (s.mode === 'config-if') { s.mode = 'config'; return createStdout(''); }
      if (s.mode === 'config') {
        s.mode = 'exec'; s.endDone = true;
        if (c.vtyExited && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
        return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip interface brief" to confirm Sw101\'s VLAN IP addresses.') : '');
      }
      return createStdout('');
    },

    sw101End() {
      const s = this.sw101; const c = this.sw101Completion;
      const wasConfig = s.mode !== 'exec';
      if (s.mode === 'config-line' && c.loginLocal && !c.vtyExited) { c.vtyExited = true; this.updateScore(); }
      if (s.mode === 'config-ext-nacl' && c.permitIp && !c.aclExited) { c.aclExited = true; this.updateScore(); }
      s.mode = 'exec';
      if (wasConfig) s.endDone = true;
      if (c.vtyExited && !c.endForVerify) { c.endForVerify = true; this.updateScore(); }
      return createStdout(c.endForVerify ? this.guide('Back in exec mode. → Next: "show ip interface brief" to confirm Sw101\'s VLAN IP addresses.') : '');
    },

    sw101Username(x) {
      const me = this.modeErr(this.sw101, 'config'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'support' && !c.username) {
        c.username = true; this.updateScore();
        return createStdout(this.guide('Created local account "support" with privilege 15 (full admin access). Uses plain "password" — this stores the password in recoverable plaintext in the config file. In production always use "secret" with a hashing algorithm. → Next: configure VTY lines for telnet.'));
      }
      return createStdout('');
    },

    sw101Line(x) {
      const me = this.modeErr(this.sw101, 'config'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'vty') {
        this.sw101.mode = 'config-line';
        if (!c.lineVty) { c.lineVty = true; this.updateScore(); }
        return createStdout(this.guide('Entered VTY line config for lines 0-4 — the 5 simultaneous remote sessions allowed. → Next: restrict these lines to Telnet only.'));
      }
      return createStderr('% Invalid input detected');
    },

    sw101Transport(x) {
      const me = this.modeErr(this.sw101, 'config-line'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'input' && x._[2] === 'telnet' && !c.transportTelnet) {
        c.transportTelnet = true; this.updateScore();
        return createStdout(this.guide('VTY lines now accept Telnet connections only — SSH and all other protocols are blocked. Telnet sends credentials as plaintext; in production use SSH instead. → Next: require local account authentication.'));
      }
      return createStdout('');
    },

    sw101Login(x) {
      const me = this.modeErr(this.sw101, 'config-line'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'local' && !c.loginLocal) {
        c.loginLocal = true; this.updateScore();
        return createStdout(this.guide('VTY lines now require authentication against the local user database. PC1 can telnet to 192.168.100.1 using "support" / "max2learn". → Next: type "exit" to leave VTY config.'));
      }
      return createStdout('');
    },

    sw101Ip(x) {
      const s = this.sw101; const c = this.sw101Completion;
      if (x._[1] === 'access-list' && x._[2] === 'extended') {
        const me = this.modeErr(s, 'config'); if (me) return me;
        s.mode = 'config-ext-nacl'; s.currentAcl = x._[3];
        if (!c.aclCreated) { c.aclCreated = true; this.updateScore(); }
        return createStdout(this.guide('Created extended named ACL "ENT_ACL". Extended ACLs match on source IP, destination IP, protocol, and port. ACL entries are evaluated top-down — first match wins, so order matters. → Next: add the four entries in the specified order.'));
      }
      if (x._[1] === 'access-group') {
        const me = this.modeErr(s, 'config-if'); if (me) return me;
        if (x._[2] === 'ENT_ACL' && x._[3] === 'in' && !c.accessGroup) {
          c.accessGroup = true; this.updateScore();
          return createStdout(this.guide('ENT_ACL applied inbound on e0/2. Important caveat: e0/2 is a Layer 2 trunk, and IOS cannot enforce a Layer 3 ACL on a L2 trunk interface. In practice this ACL would need to be applied to the SVI (VLAN interface) for it to work. This is a known limitation documented in the task. → Move to Task 3 on Sw102.'));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    sw101Permit(x) {
      const me = this.modeErr(this.sw101, 'config-ext-nacl'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'tcp' && !c.permitTelnet) {
        c.permitTelnet = true; this.updateScore();
        return createStdout(this.guide('Permitted Telnet (TCP 23) from PC2 (192.168.200.10) specifically to Sw101\'s management IP (192.168.100.1). "host" on both sides = exact /32 match. This is the one allowed exception — only PC2 can telnet to Sw101. ACL processes top-down, so this permit fires before the deny-all-telnet below. → Next: deny telnet from all other VLAN 200 devices.'));
      }
      if (x._[1] === 'ip' && !c.permitIp) {
        c.permitIp = true; this.updateScore();
        return createStdout(this.guide('Permitted all other IP traffic from VLAN 200 (192.168.200.0/24) to anywhere. Without this, only the specifically permitted TCP would work and everything else would hit the implicit deny-all. This rule preserves normal network connectivity while only restricting ICMP and Telnet. → Next: type "exit" to finalize the ACL.'));
      }
      return createStdout('');
    },

    sw101Deny(x) {
      const me = this.modeErr(this.sw101, 'config-ext-nacl'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'icmp' && !c.denyIcmp) {
        c.denyIcmp = true; this.updateScore();
        return createStdout(this.guide('Blocked ICMP (ping) from PC2 (192.168.200.10) to PC1 (192.168.100.10). "host" = exact /32 match. This stops PC2 from pinging PC1 specifically, while still allowing PC2 to ping other destinations (that rule comes after). → Next: permit Telnet from PC2 to Sw101.'));
      }
      if (x._[1] === 'tcp' && !c.denyTelnet) {
        c.denyTelnet = true; this.updateScore();
        return createStdout(this.guide('Blocked Telnet from the entire VLAN 200 subnet to anywhere. This catches all other devices in 192.168.200.0/24 trying to telnet. PC2\'s telnet was already permitted in the previous entry (first match wins), so this deny does NOT affect PC2 — only other VLAN 200 devices. → Next: permit all other VLAN 200 IP traffic.'));
      }
      return createStdout('');
    },

    sw101Interface(x) {
      const s = this.sw101; const c = this.sw101Completion;
      if (s.mode !== 'config' && s.mode !== 'config-if') return this.modeErr(s, 'config');
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e')
      s.mode = 'config-if'; s.currentInterface = raw;
      if (raw === 'e0/2' && !c.intE02) {
        c.intE02 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/2 — the trunk interface receiving VLAN 200 traffic. → Next: ip access-group ENT_ACL in'));
      }
      return createStdout('');
    },

    sw101Show(x) {
      const me = this.modeErr(this.sw101, 'exec'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'ip' && x._[2] === 'interface' && x._[3] === 'brief') {
        if (!c.verifyShowIp) { c.verifyShowIp = true; this.updateScore(); }
        return createStdout(SHOW_IFACE_BRIEF + this.guide('VLAN 100 management IP confirmed: 192.168.100.1. This is the telnet destination address used in the ACL permit rule (permit tcp ... host 192.168.100.1 eq telnet). VLAN 200 gateway is 192.168.200.1. → Next: type "configure terminal" to return to config mode and build ENT_ACL.'));
      }
      return createStderr('% Invalid input detected');
    },

    sw101Copy(x) {
      const me = this.modeErr(this.sw101, 'exec'); if (me) return me;
      const c = this.sw101Completion;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Sw101 config saved to NVRAM — user account, VTY telnet config, and ENT_ACL all persist across reboots.' + (this.saveDone ? ' ✓ Both switches saved — simulation complete!' : ' → Save Sw102 too.')));
      }
      return createStderr('% Invalid input detected');
    },

    // ── Sw102 ────────────────────────────────────────────────────
    sw102Configure(x) {
      const me = this.modeErr(this.sw102, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this.sw102.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    sw102Exit() {
      const s = this.sw102;
      if (s.mode === 'config-if') { s.mode = 'config'; return createStdout(''); }
      if (s.mode === 'config') { s.mode = 'exec'; s.endDone = true; return createStdout(''); }
      return createStdout('');
    },

    sw102End() {
      const s = this.sw102;
      if (s.mode !== 'exec') s.endDone = true;
      s.mode = 'exec';
      return createStdout('');
    },

    sw102Interface(x) {
      const s = this.sw102; const c = this.sw102Completion;
      if (s.mode !== 'config' && s.mode !== 'config-if') return this.modeErr(s, 'config');
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e')
      s.mode = 'config-if'; s.currentInterface = raw;
      if (raw === 'e0/0' && !c.intE00) {
        c.intE00 = true; this.updateScore();
        return createStdout(this.guide('Entered e0/0 on Sw102 — the interface to secure with port security. Port security restricts which MAC addresses can send frames through this port, limiting how many devices or which specific devices can connect. → Next: enable port security.'));
      }
      return createStdout('');
    },

    sw102Switchport(x) {
      const s = this.sw102; const c = this.sw102Completion;
      const me = this.modeErr(s, 'config-if'); if (me) return me;
      if (s.currentInterface !== 'e0/0') {
        return createStderr('% Port security commands must be applied on e0/0 — type "interface e0/0" first');
      }
      const sub = x._[1];
      if (sub !== 'port-security') return createStderr('% Invalid input detected');

      const sub2 = x._[2];
      if (sub2 === undefined && !c.portSecurity) {
        c.portSecurity = true; this.updateScore();
        return createStdout(this.guide('Port security enabled on e0/0. By default, only 1 MAC address is allowed and the first MAC seen on the port is dynamically learned and secured. → Next: increase the maximum allowed MACs.'));
      }
      if (sub2 === 'maximum' && !c.portSecMax) {
        c.portSecMax = true; this.updateScore();
        return createStdout(this.guide('Maximum of 4 MAC addresses allowed on this port. Up to 4 distinct devices (or a downstream hub with 4 hosts) can connect. The 5th unique MAC triggers the violation action. → Next: set the violation mode.'));
      }
      if (sub2 === 'violation' && x._[3] === 'protect' && !c.portSecViolation) {
        c.portSecViolation = true; this.updateScore();
        return createStdout(this.guide('"Protect" violation mode: when a new MAC exceeds the limit, frames from that MAC are silently dropped — no log, no SNMP trap, no port shutdown. The task says "no notification action required" which maps directly to protect. (Restrict = drop + notify; Shutdown = disable the port entirely.) → Save both switch configs.'));
      }
      return createStdout('');
    },

    sw102Copy(x) {
      const me = this.modeErr(this.sw102, 'exec'); if (me) return me;
      const c = this.sw102Completion;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Sw102 config saved to NVRAM — port security settings on e0/0 persist across reboots.' + (this.saveDone ? ' ✓ Both switches saved — simulation complete!' : ' → Save Sw101 too.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw101_terminal, #sw102_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

